// extracted by mini-css-extract-plugin
module.exports = {"headerSurveyClosedBanner":"SurveyClosedBanner_headerSurveyClosedBanner__Xw1Mp","icon":"SurveyClosedBanner_icon__dRvVP","innerContainer":"SurveyClosedBanner_innerContainer__473NO"};